/* istanbul ignore file */

import fetchUserExperimentVariations from './fetchUserExperimentVariations';

export { default as fetchUserExperimentVariations } from './fetchUserExperimentVariations';

export default {
  fetchUserExperimentVariations,
};
